module.exports = __webpack_public_path__ + "static/media/AdviseeEstatePlanning.d542252b.svg";